import React, { useEffect } from "react";
import "./AddFiles.scss";
import { union } from "../../shared/images/icons";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import {
  redirectFrom,
  sedFilesForMobi,
  sendFiles,
  throwErrorMessage,
} from "../../actions/Actions";
import { useHistory } from "react-router-dom";
import Button from "../../shared/Button/Button";
import { canSendFiles } from "../../utils";
import reflect from "../../translate/translations";
import { DragAndDrop } from "../../shared/DragAndDrop/DragAndDrop";

export const AddFiles = ({ isForMobi }) => {
  const { lang, selectedPassportType } = useSelector(
    (state) => state.mainState
  );
  const router = useSelector((state) => state.router.location);
  // eslint-disable-next-line
  const [uploadFilesCount, setUploadFilesCount] = useState({
    upload: {
      newPassport: [
        { text: "new_pass_front", type: "new_pass_front" },
        { text: "new_pass_back", type: "new_pass_back" },
        { text: "reference", type: "document_1" },
      ],
      oldPassport: [
        { text: "old_pass_front", type: "old_pass_front" },
        { text: "old_pass_back", type: "old_pass_back" },
        { text: "inn", type: "inn_document" },
        { text: "reference", type: "document_1" },
      ],
    },
    default: {
      newPassport: [
        { text: "new_pass_front", type: "new_pass_front" },
        { text: "new_pass_back", type: "new_pass_back" },
        { text: "reference", type: "document_1" },
      ],
      oldPassport: [
        { text: "old_pass_front", type: "old_pass_front" },
        { text: "old_pass_back", type: "old_pass_back" },
        { text: "inn", type: "inn_document" },
        { text: "reference", type: "document_1" },
      ],
    },
    alifshop: {
      newPassport: [
        { text: "new_pass_front", type: "new_pass_front" },
        { text: "new_pass_back", type: "new_pass_back" },
        { text: "reference", type: "document_1" },
      ],
      oldPassport: [
        { text: "old_pass_front", type: "old_pass_front" },
        { text: "old_pass_back", type: "old_pass_back" },
        { text: "inn", type: "inn_document" },
      ],
    },
    km: {
      newPassport: [
        { text: "new_pass_front", type: "new_pass_front" },
        { text: "new_pass_back", type: "new_pass_back" },
        { text: "reference", type: "document_1" },
      ],
      oldPassport: [
        { text: "old_pass_front", type: "old_pass_front" },
        { text: "old_pass_back", type: "old_pass_back" },
        { text: "inn", type: "inn_document" },
      ],
    },
    visa: {
      newPassport: [
        { text: "new_pass_front", type: "new_pass_front" },
        { text: "new_pass_back", type: "new_pass_back" },
        { text: "reference_visa", type: "document_1" },
      ],
      oldPassport: [
        { text: "old_pass_front", type: "old_pass_front" },
        { text: "old_pass_back", type: "old_pass_back" },
        { text: "inn", type: "inn_document" },
        { text: "reference_visa", type: "document_1" },
      ],
    },
    sm: {
      newPassport: [
        { text: "Загрузите переднюю сторону паспорта", type: "new_pass_front" },
        { text: "Загрузите обратную сторону паспорта", type: "new_pass_back" },
        { text: "Загрузите справку о доходах", type: "document_1" },
      ],
      oldPassport: [
        {
          text: "Загрузите cтраницу с персональными данными",
          type: "old_pass_front",
        },
        { text: "Загрузите страницу с пропиской", type: "old_pass_back" },
        { text: "Загрузите страницу с ИНН", type: "inn_document" },
        { text: "Загрузите справку о доходах", type: "document_1" },
      ],
    },
    auto: {
      newPassport: [
        { text: "Загрузите переднюю сторону паспорта", type: "new_pass_front" },
        { text: "Загрузите обратную сторону паспорта", type: "new_pass_back" },
        { text: "Загрузите справку о доходах", type: "document_1" },
      ],
      oldPassport: [
        {
          text: "Загрузите cтраницу с персональными данными",
          type: "old_pass_front",
        },
        { text: "Загрузите страницу с пропиской", type: "old_pass_back" },
        { text: "Загрузите страницу с ИНН", type: "inn_document" },
        { text: "Загрузите справку о доходах", type: "document_1" },
      ],
    },
    mobi: {
      newPassport: [
        { text: "Загрузите документ", type: "new_pass_front" },
        { text: "Загрузите документ", type: "new_pass_back" },
        { text: "Загрузите документ", type: "document_1" },
        { text: "Загрузите документ", type: "document_1" },
        { text: "Загрузите документ", type: "document_1" },
      ],
      oldPassport: [
        {
          text: "Загрузите cтраницу с персональными данными",
          type: "old_pass_front",
        },
        { text: "Загрузите страницу с пропиской", type: "old_pass_back" },
        { text: "Загрузите страницу с ИНН", type: "inn_document" },
        { text: "Загрузите справку о доходах", type: "document_1" },
      ],
    },
  });
  const [redirect, setRedirect] = useState("default");
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [uploadPermission, setUploadPermission] = useState(false);

  useEffect(() => {
    if (router.pathname === "/mobi" && isForMobi === false) {
      sedFilesForMobi(true);
    }
    setRedirect(router?.pathname?.replace("/", "") || "default");
    dispatch(redirectFrom(router?.pathname?.replace("/", "") || "default"));
    return () => {};
    // eslint-disable-next-line
  }, [router.pathname, isForMobi]);
  const { app_id } = useSelector((state) => state.checkOtpState);
  const { client_id } = useSelector((state) => state.mainState);
  const handleCollectFiles = (evt, type) => {
    const existing = files.find((o) => evt === o.file);
    if (!existing) {
      setFiles([...files, { file: evt, type: type }]);
    }
    setUploadPermission(canSendFiles(files, selectedPassportType, isForMobi));
  };
  const handleRemoveFiles = (evt) => {
    const file = files.find((o) => evt === o.file);
    if (file) {
      let d = files.filter((o) => o.file !== file.file);
      setFiles([...d]);
    }
    setUploadPermission(canSendFiles(files, selectedPassportType, isForMobi));
  };
  const handleError = (error) => {
    dispatch(throwErrorMessage(error));
  };
  const history = useHistory();
  const sendRoistatEvent = () => {
    switch (redirect) {
      case "sm":
        // eslint-disable-next-line no-undef
        roistat.event.send("doc_website_from_salom_docs_sent");
        break;
      case "auto":
        // eslint-disable-next-line no-undef
        roistat.event.send("doc_website_from_auto_docs_sent");
        break;
      case "visa":
        // eslint-disable-next-line no-undef
        roistat.event.send("doc_website_from_visa_docs_sent");
        break;
      case "alifshop":
        // eslint-disable-next-line no-undef
        roistat.event.send("doc_website_from_alifshop_docs_sent");
        break;
      case "default":
        // eslint-disable-next-line no-undef
        roistat.event.send("doc_website_docs_sent");
        break;
      default:
        break;
    }
  };
  const handleSubmit = () => {
    if (uploadPermission) {
      sendRoistatEvent();
      if (redirect === "mobi") {
        dispatch(sedFilesForMobi(files));
      } else {
        dispatch(sendFiles(files, app_id, client_id, history));
      }
    }
  };

  const mapDragAndDrops = (passportType, pageType = "default") => {
    switch (passportType) {
      case 1:
        return uploadFilesCount[pageType]?.newPassport?.map((item, index) => (
          <DragAndDrop
            fileadd={handleCollectFiles}
            fileremove={handleRemoveFiles}
            sizeError={() => handleError("sizeError")}
            typeError={() => handleError("typeError")}
            text={reflect.t(item.text) ? reflect.t(item.text) : item.text}
            type={item.type}
            lang={lang}
            key={index + "drag_and_drop"}
          />
        ));
      case 2:
        return uploadFilesCount[pageType]?.oldPassport?.map((item, index) => (
          <DragAndDrop
            fileadd={handleCollectFiles}
            fileremove={handleRemoveFiles}
            sizeError={() => handleError("sizeError")}
            typeError={() => handleError("typeError")}
            text={reflect.t(item.text) ? reflect.t(item.text) : item.text}
            type={item.type}
            lang={lang}
            key={index + "drag_and_drop"}
          />
        ));
      default:
        return null;
    }
  };
  return (
    <div className="AddFiles">
      {!isForMobi && (
        <>
          <div className="d-flex">
            <p className="headingUpload">
              {reflect.t("upload_files")}{" "}
              {!redirect === "visa" && !redirect === "km" && (
                <span
                  className="pl-1 union"
                  onClick={() => dispatch(throwErrorMessage("information"))}
                >
                  {union}
                </span>
              )}
            </p>
          </div>
          <p className="sizeDescription">
            Файл должен быть в формате jpg, png или pdf, объёмом не больше 6 Мб.
          </p>
        </>
      )}
      {mapDragAndDrops(selectedPassportType, redirect)}
      <div className="row">
        <div className="col-md-4 col-xs-12 col-lg-4">
          <div className="submitButton">
            <Button
              label={reflect.t("send_files")}
              submitPermission={uploadPermission}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
